import React from "react";
import { lePetitPrinceImages } from "../../../../../../Assets/images/le-petit-prince";
import StyledDiv from "../../../../../StyledDiv/StyledDiv";
import { IStyledDivStyles } from "../../../../../StyledDiv/StyledDiv";

interface IAsteroideGrayProps {
  styles?: IStyledDivStyles;
}

const AsteroideGray = ({ styles }: IAsteroideGrayProps) => {
  return (
    <StyledDiv styles={styles} className="asteroide-gray">
      <img
        src={lePetitPrinceImages.asteroideGray}
        alt="Gray asteroid"
        style={{ width: "auto", height: "auto" }}
      />
    </StyledDiv>
  );
};

export default AsteroideGray;
